import {useCallback, useState} from "react";
import {DVIRReviewForm, DVIRReviewFormProps, DVIRReviewFormValues} from "./DVIRReviewForm";
import {SignatureModal} from "../../signature/SignatureModal/SignatureModal";

export type DVIRReviewFormWithSignatureValues = {
  form: DVIRReviewFormValues
  signature: { mimeType: string; dataUrl: string };
}

export type DVIRReviewFormWithSignatureProps = Omit<DVIRReviewFormProps, "onSubmit"> & {
  onSubmit?: (values: DVIRReviewFormWithSignatureValues) => void
};

export const DVIRReviewFormWithSignature = (props: DVIRReviewFormWithSignatureProps) => {
  const {
    onSubmit,
    ...rest
  } = props;

  const [pendingForm, setPendingForm] = useState<DVIRReviewFormValues | undefined>(undefined);
  const [signatureOpen, setSignatureOpen] = useState(false);

  const onFormSubmit = useCallback((values: DVIRReviewFormValues) => {
    setPendingForm(values);
    setSignatureOpen(true);
  }, []);

  const onSignatureSubmit = useCallback((signature: { mimeType: string; dataUrl: string }) => {
    if (onSubmit) {
      if (!pendingForm) {
        return;
      }

      onSubmit({
        form: pendingForm,
        signature: signature
      });

      setSignatureOpen(false);
      setPendingForm(undefined);
    }
  }, [pendingForm, onSubmit])

  const onSignatureClose = useCallback(() => {
    setSignatureOpen(false);
    setPendingForm(undefined);
  }, [])

  return (
    <>
      <DVIRReviewForm {...rest} onSubmit={onFormSubmit}/>
      <SignatureModal
        opened={signatureOpen}
        onClose={onSignatureClose}
        onSubmit={onSignatureSubmit}
      />
    </>
  );
};
